import React from 'react';

const KovFooterRightSection = ({ helpSectionLink, children }) => {
  return (
    <div className="help-circle-container">
      {helpSectionLink?.text && helpSectionLink?.href && (
        <>
          <span data-testid="help-icon" className="help-circle-new">
            ?
          </span>
          <a data-testid="help-link" href={helpSectionLink.href} target="_blank" rel="noreferrer">
            <span className="help-text">{helpSectionLink.text}</span>
          </a>
        </>
      )}
      {children}
    </div>
  );
};

export default KovFooterRightSection;
